export const SAVE_LOGIN_INFO = "SAVE_LOGIN_INFO";
export const SAVE_DPO_CONFIG_ID = "SAVE_DPO_CONFIG_ID";
export const SAVE_SYSTEM_CONFIG_CONFIG_ID = "SAVE_SYSTEM_CONFIG_CONFIG_ID";
export const SAVE_DATA_PROCESSOR_ID = "SAVE_DATA_PROCESSOR_ID";
export const SAVE_PURPOSE_ID = "SAVE_PURPOSE_ID";
export const SAVE_LOGIN_USER_PROFILE_DETAILS =
  "SAVE_LOGIN_USER_PROFILE_DETAILS";
export const SET_PORTAL_THEME = "SET_PORTAL_THEME";

export const SAVE_SIGNUP_INFO = "SAVE_SIGNUP_INFO";
export const SAVE_ONBOARD_INFO = "SAVE_ONBOARD_INFO";
export const SAVE_USER_PROFILE = "SAVE_USER_PROFILE";
export const CLEAR_SESSION = "CLEAR_SESSION";
export const SAVE_TEMPLATES = "SAVE_TEMPLATES";
export const SAVE_CUSID_TNTID = "SAVE_CUSID_TNTID";
export const SET_BUSINESS_NAME = "SET_BUSINESS_NAME";
export const SET_BUSINESS_LOGO = "SET_BUSINESS_LOGO";
export const GRIEVANCE_STATUS = {
  GRIEVANCE_RAISED: "RAISED",
  GRIEVANCE_INPROCESS: "INPROCESS",
  GRIEVANCE_L1_ESCALATED: "L1_ESCALATED",
  GRIEVANCE_L2_ESCALATED: "L2_ESCALATED",
  GRIEVANCE_RESOLVED: "RESOLVED",
  NEW: "NEW",
};

export const SET_PARENT_CONSENT_METADATA = "SET_PARENT_CONSENT_METADATA";
export const SET_PARENT_CODE = "SET_PARENT_CODE";
export const SET_PARENT_STATE = "SET_PARENT_STATE";

export const SAVE_INTEGRATION_IDS = "SAVE_INTEGRATION_IDS";

// Language/Translation Constants
export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";
export const SET_TRANSLATIONS = "SET_TRANSLATIONS";
export const SET_IS_TRANSLATING = "SET_IS_TRANSLATING";
